import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { User } from "../models/User";

export const getUsers = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[SEC].[GetUsers]", []);
	return resp;
};

export const getDataUser = async (UserId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "UserId", value: UserId });
	parameters.push({ name: "UserName", value: null });
	const resp = await apiService.callV2("[SEC].[GetUser]", parameters);
	return resp;
};

export const getProfiles = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[SEC].[GetProfiles]", []);
	return resp;
};

export const deleteUser = async (userId: number) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	parameters.push({ name: "UserId", value: userId });
	const resp = await apiService.callV2("[SEC].[DeleteUser]", parameters);
	return resp;
};

//  inserta una nueva fila o actualiza una fila existente
export const setPassword = async (userId: number, password: string) => {
	const apiService = new MESApiService();

	try {
		const resp = await apiService.changePassword(userId.toString(), password);
		return {
			ok: true,
			data: resp,
		};
	} catch (e: any) {
		return { ok: false, message: e.toString() };
	}
};

export const upsertUser = async (user: User) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "UserId", value: user.UserId });
	parameters.push({ name: "UserName", value: user.UserName });
	parameters.push({ name: "Name", value: user.FirstName });
	parameters.push({ name: "LastName", value: user.LastName });
	parameters.push({ name: "AuthTypeId", value: user.AuthTypeId });
	parameters.push({ name: "IsActive", value: user.IsActive });

	const resp = await apiService.callV2("[SEC].[UpsertUser]", parameters);
	return resp;
};

export const getAuthTypes = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[SEC].[GetAuthTypes]", []);
	return resp;
};

export const setProfilesToUser = async (
	UserId: number,
	profileIds: number[],
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "UserId", value: UserId });
	parameters.push({ name: "ProfileIds", value: profileIds.join(" , ") });
	const resp = await apiService.callV2("[SEC].[setProfilesToUser]", parameters);
	return resp;
};
